import { ASKED_TO_UNMUTE_SOUND_ID } from '../../../../react/features/av-moderation/constants';
import { hideDialog } from '../../../../react/features/base/dialog/actions';
import { translate } from '../../../../react/features/base/i18n/functions';
import { playSound } from '../../../../react/features/base/sounds/actions';
import Dialog from '../../../../react/features/base/ui/components/web/Dialog';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import WildixUIEvents from '../../../service/WildixUIEvents';
import { LOGOUT_FROM_WIZYCONF_ROOM } from '../../../wizyconf/constants';

import {
    POPUP_ALONE_INTERVAL,
    POPUP_ALONE_SECONDS
} from '../constants';

class PopupAlone extends Component {
    constructor(props) {
        super(props);
        this.state = {
            interval: null,
            seconds: POPUP_ALONE_SECONDS
        };
        this.tick = this.tick.bind(this);
        this.onStayAlone = this.onStayAlone.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    componentDidMount() {
        this.onStayAlone();
    }

    componentWillUnmount() {
        this.clearTimeouts();
    }

    onStayAlone() {
        const { dispatch } = this.props;

        dispatch(playSound(ASKED_TO_UNMUTE_SOUND_ID));
        this.setState({
            interval: setInterval(this.tick, POPUP_ALONE_INTERVAL)
        });
        APP.wildix.eventEmitter.emit(WildixUIEvents.DIALOG_OPENED, { type: 'popup-alone' });
    }

    onSubmit() {
        const { dispatch } = this.props;

        dispatch(hideDialog());
        this.clearTimeouts();
        if (APP.isExternalProvider) {
            APP.xBeesEvents.destroyIframe();
        } else if (APP.wildix.wizy) {
            window.postMessage(LOGOUT_FROM_WIZYCONF_ROOM, '*');
        } else {
            APP.conference.hangup();
        }
    }

    onCancel() {
        this.clearTimeouts();
    }

    tick() {
        this.setState(({ seconds }) => {
            return { seconds: seconds - 1 };
        });
        if (this.state.seconds <= 0) {
            this.onSubmit();
        }
    }

    clearTimeouts() {
        const { interval } = this.state;

        clearInterval(interval);
        this.setState({
            interval: null,
            seconds: POPUP_ALONE_SECONDS
        });
        APP.wildix.eventEmitter.emit(WildixUIEvents.DIALOG_CLOSED, { type: 'popup-alone' });
    }

    render() {
        const { t } = this.props;
        const { seconds } = this.state;
        const props = {
            titleKey: 'notify.aloneMessageTitle',
            ok: { translationKey: 'notify.leave' },
            cancel: { translationKey: 'notify.stay' },
            hideCloseButton: true,
            disableBackdropClose: true,
            onSubmit: this.onSubmit,
            onCancel: this.onCancel
        };

        return (
            <Dialog {...props}>
                <div className={'popup-alone__description'}>
                    {t('notify.aloneMessageDescription', { seconds })}
                </div>
            </Dialog>
        );
    }
}

export default connect()(translate(PopupAlone));
